var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallMenuClose = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6.5)",
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 13,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 17,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.547 23.052a1.57 1.57 0 0 1-2.197 0l-6.741-6.604a2.026 2.026 0 0 1-.118-2.77l.118-.126 6.741-6.604a1.57 1.57 0 0 1 2.197 0c.596.584.605 1.539.02 2.133L20.526 15l6.021 5.899c.568.556.603 1.448.1 2.045l-.1.108z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallMenuClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-menu-close.a570c374cc4d28ed57e2a6dd1508be06.svg";